<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<h1>Lost shipments</h1>
		<Modal v-if="comments_id" v-on:close="comments_id = false;">
			<Comments resource="LostShipment" :id="comments_id" />
		</Modal>
		<div class="margin-top flex justify-space-between">
			<MaterialText
				class="small-margin-right"
				:disabled="saving"
				v-model="search_tracking_number"
				v-on:enter="search()"
				v-on:focus="show_note = true;"
				v-on:blur="show_note = false;"
				label="Tracking number" />
			<div class="flex align-items-center show-only-block">
				<p>Show Only:</p>
				<select v-model="resolved_status" v-on:change="setResolved(resolved_status)">
					<option value="unresolved">Unresolved</option>
					<option value="resolved">Resolved</option>
				</select>
			</div>
			<div v-if="create.id" class="flex">
				<MaterialText :disabled="true" v-model="create.id" label="Record ID" />
				<button class="small-margin-left" v-on:click="submit()" :disabled="saving">Submit</button>
				<button class="small-margin-left gray" v-on:click="cancel()" :disabled="saving">Cancel</button>
			</div>
		</div>
		<div v-if="show_note" class="note small-margin-top">
			Press <strong>Enter</strong> to search
		</div>
		<div class="flex small-margin-top justify-space-between align-itemes-center">
			<div ref="customPaginator" class="paginator flex">
				<jw-pagination :items="rows" :pageSize="computedPageNum" :maxPages="maxPages" @changePage="onChangePage"></jw-pagination>
			</div>
			<div class="flex align-itemes-center num-per-page">
				<p>Per Page:</p>
				<select v-model="perPage" @change="setPerPage(perPage)">
					<option value="5">5</option>
					<option value="10">10</option>
					<option value="20">20</option>
					<option value="50">50</option>
					<option value="100">100</option>
				</select>
			</div>
		</div>
		<div class="margin-top">
			<table>
				<thead>
					<tr>
						<th>ID</th>
						<th>Order</th>
						<th>Type</th>
						<th>Tracking number</th>
						<th>Resolved at</th>
						<th>Status</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="row in pageOfItems" :key="row.id">
						<td>{{ row.id }}</td>
						<td>
							<OrderLink :id="row.order_id" />
						</td>
						<td>{{ row.type }}</td>
						<td>{{ row.tracking_number }}</td>
						<td>{{ row.resolved_at }}</td>
						<td>
							<select v-model="row.status" v-on:change="updateStatus(row)">
								<option value="">[ None ]</option>
								<option :value="status" v-for="status in statuses">
									{{ status }}
								</option>
							</select>
						</td>
						<td class="text-right">
							<button
								:disabled="saving"
								class="small gray small-margin-right"
								v-if="!row.resolved_at"
								v-on:click="resolve(row.id)">Resolve</button>

							<button
								:disabled="saving"
								class="small gray small-margin-right"
								v-on:click="comments_id = row.id">Comments</button>

							<a target="_blank" :href="row.url"><button class="small gray">Open URL</button></a>
						</td>
					</tr>
				</tbody>
			</table>
			<!-- <Table :columns="columns" :rows="rows" /> -->
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import JwPagination from 'jw-vue-pagination'
Vue.component('jw-pagination', JwPagination)

export default {
  data: () => ({
  	// API request options
  	perPage: 5,
  	page: 1,
  	resolved_status: 'unresolved',
    maxPages: 5,
    show_note: false,
    search_tracking_number: '',
    comments_id: false,
    loading: false,
    saving: false,
    statuses: [],
    records: [],
    create: {},
    columns: {
      id: {},
      order_id: {},
      type: {},
      tracking_number: {},
      // url: {},
      resolved_at: {},
      status: {}
    },
    pageOfItems: [],
    resolved_orders: [],
    unresolved_orders: []
  }),
  computed: {
    rows () {
      return this.records
    },
    computedPageNum () {
      return this.perPage
    }
  },
  methods: {
    cancel () {
      this.search_tracking_number = ''
      this.create = {}
    },
    updateStatus (row) {
      Vue.$api.patch('/lost-shipment/' + row.id, row, {
        before: () => this.saving = true,
        always: () => this.saving = false
      })
    },
    resolve (id) {
      Vue.$api.post('/tracking/' + id + '/resolve', {}, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: data => this.load()
      })
    },
    search () {
      Vue.$api.get('/tracking/number/' + this.search_tracking_number, {}, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: data => {
          this.create.id = data.id
        }
      })
    },
    load () {
      Vue.$api.get('/shipments/lost', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => {
        	this.parse(data)
        }
      })
    },
    submit () {
      Vue.$api.post('/tracking/' + this.create.id + '/lost', {}, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: data => this.load()
      })
    },
    parse (data) {
    	// Table data
      this.resolved_orders = data.lost_shipments.filter((item) => item.resolved_at !== null)
      this.unresolved_orders = data.lost_shipments.filter((item) => item.resolved_at == null)
      this.records = this.unresolved_orders
      this.statuses = data.statuses
    },
    setResolved (resolvedStatus) {
      if (resolvedStatus == 'resolved') {
        this.records = this.resolved_orders
      } else {
        this.records = this.unresolved_orders
      }
    },
    setPerPage (perPage) {
    	this.perPage = Number(perPage)
    },
    onChangePage (rows) {
      this.pageOfItems = rows
    }
  },
  created () {
    this.load()

    if (this.$route.query.tid) {
      this.create.id = this.$route.query.tid
    }
  }
}
</script>

<style lang="less" scoped>
.justify-space-between {
	justify-content: space-between;
}
.align-itemes-center {
	align-items: center;
}
.show-only-block {
	p {
		font-weight: 500;
	}
	select {
		padding: 6px 10px;
		margin-left: 10px;
	}
}
.num-per-page {
	p {
		font-weight: 500;
	}
	select {
		padding: 6px 10px;
		margin-left: 10px;
	}
}
.pagination {
	li {
		a {
			border: 1px solid blue;
			&.active {
				background-color: aqua !important;
			}
		}
	}
}
</style>
